export const LIST_ROW_STATUS = {
  NEW: 'new', // user found after submitting friend code (if not friend or invitation)
  FRIEND: 'friend', // common friend
  BLOCKED: 'blocked', // friend blocked by me
  PENDING: 'pending', // invitation sent to me
  WAITING: 'waiting', // invitation sent by me
};

// map used to request data by id from different collections
export const STATUS_ID_TYPE_MAP = {
  [LIST_ROW_STATUS.NEW]: 'friendcode',
  [LIST_ROW_STATUS.PENDING]: 'invite',
  [LIST_ROW_STATUS.WAITING]: 'invite',
  [LIST_ROW_STATUS.FRIEND]: 'friend',
  [LIST_ROW_STATUS.BLOCKED]: 'friend',
};

// map used to report user by appropriate id
export const STATUS_ID_REPORT_MAP = {
  [LIST_ROW_STATUS.NEW]: 'uid',
  [LIST_ROW_STATUS.PENDING]: 'invite',
  [LIST_ROW_STATUS.WAITING]: 'invite',
  [LIST_ROW_STATUS.FRIEND]: 'friend',
  [LIST_ROW_STATUS.BLOCKED]: 'friend',
};
// map used for translations in comet chat user list
export const INFO_TEXT_IDS = {
  [LIST_ROW_STATUS.PENDING]: 'RadarView_fmanage_status_requested',
  [LIST_ROW_STATUS.WAITING]: 'RadarView_fmanage_status_pending',
  [LIST_ROW_STATUS.NEW]: 'RadarView_fmanage_status_request',
  [LIST_ROW_STATUS.FRIEND]: 'RadarView_fmanage_status_friends',
  [LIST_ROW_STATUS.BLOCKED]: 'RadarView_fmanage_status_blocked',
};

export const RECOMMENDATION_REPORT_ID = 'recommendation';

export const getConversationId = (id1, id2) => [id1, id2].sort().join('_user_');
